import React, { useEffect, useState } from "react";
import axios from "axios";
import { format } from "date-fns";
import { is } from "date-fns/locale";
import BlockRenderer from "../components/BlockRenderer";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

function NewsArticlePage({ data }) {
    const [latestNews, setLatestNews] = useState([]);


    useEffect(() => {
        const fetchLatestNews = async () => {
            if (!data.parent_id) {
                return;
            }
            try {
                const response = await axios.get(
                    `${API_BASE_URL}/api/v2/pages/?child_of=${data.parent_id}&limit=4`
                );
                let articles = response.data.items || [];
                articles = articles.filter((article) => article.id !== data.id);
                setLatestNews(articles.slice(0, 3));
            } catch (err) {
                console.error("Error fetching latest news:", err);
            }
        };

        if (data && data.id) {
            fetchLatestNews();
        }
    }, [data]);

    return (
        <div className="news-article-page">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 intro-col">
                        <div className="btn-container">
                            <a href="/frettir" className="d-flex back">
                                <div className="green-arrow-btn small">
                                    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22.667 9H19.3337H22.667ZM1.33366 9L9.33366 17L1.33366 9ZM1.33366 9L9.33366 1L1.33366 9ZM1.33366 9H15.3337H1.33366Z" fill="#ffffff" />
                                        <path d="M22.667 9H19.3337M1.33366 9L9.33366 17M1.33366 9L9.33366 1M1.33366 9H15.3337" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className="btn-default back">Til baka</div>
                            </a>
                        </div>
                        <h1 className="news-title">{data.title}</h1>
                        <div className="news-meta">
                            <span className="date font-suisse">
                                {data.date
                                    ? format(new Date(data.date), "d. MMMM yyyy", { locale: is })
                                    : (data.meta && data.meta.first_published_at
                                        ? format(new Date(data.meta.first_published_at), "d. MMMM yyyy", { locale: is })
                                        : ""
                                    )
                                }
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {data.news_image && (
                <div className="news-image-container container-fluid">
                    <img
                        src={
                            data.news_image.original?.startsWith("http")
                                ? data.news_image.original
                                : `${API_BASE_URL}${data.news_image.original}`
                        }
                        alt="News"
                        className="news-image w-full h-auto rounded-lg shadow-md mb-6"
                    />
                </div>
            )}
            {data.body && Array.isArray(data.body) && data.body.length > 0 && (
                <div className="container-fluid">
                    <BlockRenderer blocks={data.body} />
                </div>
            )}

            {latestNews.length > 0 && (
                <div className="related-news-section py">
                    <div className="container-fluid py-0">
                        <div className="row">
                            <div className="col-12">
                                <span className='eyebrow'>Í fréttum</span>
                                <h2>Aðrar fréttir</h2>
                            </div>
                        </div>
                        <div className="row">
                            {latestNews.map((article, page_ptr) => (
                                <div key={article.id} className="col-md-4 news-col">
                                    <a
                                        href={article.meta.page_ptr?.url || `/frettir/${article.meta.slug}`}
                                        className="news-card d-flex h-100"
                                    >
                                        <div className="d-md-flex flex-md-column justify-content-between">
                                            <h4 className="light title">{article.title}</h4>
                                            <span className="font-suisse date">
                                                {article.date
                                                    ? format(new Date(article.date), "d. MMMM yyyy", { locale: is })
                                                    : (article.meta && article.meta.first_published_at
                                                        ? format(new Date(article.meta.first_published_at), "d. MMMM yyyy", { locale: is })
                                                        : ""
                                                    )
                                                }
                                            </span>
                                        </div>
                                        <div className="green-arrow-btn small">
                                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.3335 16H8.66683H5.3335ZM26.6668 16L18.6668 8L26.6668 16ZM26.6668 16L18.6668 24L26.6668 16ZM26.6668 16H12.6668H26.6668Z" fill="#ffffff" />
                                                <path d="M5.3335 16H8.66683M26.6668 16L18.6668 8M26.6668 16L18.6668 24M26.6668 16H12.6668" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default NewsArticlePage;
